import './SecondaryButton.css';

const SecondaryButton = ({ buttonText, onClick, children, disabled }) => (
  <div className="text-center">
    <button className="secondary-button" onClick={onClick} disabled={disabled}>
      {children ?? buttonText}
    </button>
  </div>
);

export { SecondaryButton };
